// src/components/ui/card.tsx
import * as React from "react";

type BaseProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

export const Card: React.FC<BaseProps> = ({ children, className = "", style }) => (
  <div
    className={`rounded-xl border border-border bg-card text-card-foreground shadow-sm ${className}`}
    style={style}
  >
    {children}
  </div>
);

export const CardContent: React.FC<BaseProps> = ({ children, className = "", style }) => (
  <div className={`p-6 ${className}`} style={style}>
    {children}
  </div>
);

export const CardHeader: React.FC<BaseProps> = ({ children, className = "", style }) => (
  <div className={`px-4 pt-4 ${className}`} style={style}>
    {children}
  </div>
);

export const CardTitle: React.FC<BaseProps> = ({ children, className = "", style }) => (
  <h4
    className={`text-md font-semibold leading-none tracking-tight text-card-foreground ${className}`}
    style={style}
  >
    {children}
  </h4>
);